import { SavingAccount } from '../../types/savingAccount'
import { Cryptocurrency } from '../../types/currency'
import { server } from '../utils/config'

export async function getSavingsAccounts(
  type: 'defi' | 'cefi',
  currency?: Cryptocurrency,
): Promise<SavingAccount[]> {
  const filter = currency?.code || 'USDC'
  const url = `${server}/api/saving-accounts?currency=${encodeURIComponent(filter)}&type=${type}`

  const res = await fetch(url.toString())

  if (res.status !== 200) {
    return []
  }

  const data = (await res.json()) as SavingAccount[]

  const sortedData = data.sort((a, b) =>
    (a.interestRate?.rate || 0) > (b.interestRate?.rate || 0) ? -1 : 1,
  )

  return sortedData
}

export async function getSavingsAccountFromStrapi(type: 'DeFi' | 'CeFi'): Promise<SavingAccount[]> {
  const url = new URL(`${process.env.NEXT_PUBLIC_STRAPI_URL}/saving-accounts`)
  url.searchParams.append('_sort', 'rating:desc')
  url.searchParams.append('type', type)
  const res = await fetch(url.toString())
  if (res.status !== 200) {
    return []
  }

  const data = (await res.json()) as SavingAccount[]

  return data
}
